// Paket P1 — PromoDialog (60_PROMOTION.md §5).
//
// Wickelt den PromoHero-Kopf in einen ResponsiveDialog, listet Vorteile
// mit check-Icons in Stufenfarbe, rendert den PromoCta in voller Breite
// und einen "Später"-Textknopf darunter. Schliesst ueber onClose.

import { Icon } from '../ui';
import { ResponsiveDialog } from '../ui/ResponsiveDialog';
import { useT } from '../../i18n';
import { PromoCta } from './PromoCta';
import { PromoHero } from './PromoHero';
import type { TierMarkTier } from './TierMark';
import type { IconName } from '../ui/Icon';
import styles from './PromoDialog.module.css';

export interface PromoDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  /** Sub-Titel/Fliesstext unter dem Titel im Hero. */
  text?: string;
  /** Bullet-Punkte unter dem Hero. */
  benefits: string[];
  ctaLabel: string;
  onCta: () => void;
  /** Optionales Label fuer den Text-Button "Später" (Default = i18n). */
  laterLabel?: string;
  tier?: TierMarkTier;
  icon?: IconName;
  ribbon?: string;
}

export function PromoDialog({
  open,
  onClose,
  title,
  text,
  benefits,
  ctaLabel,
  onCta,
  laterLabel,
  tier = 'ultra',
  icon = 'flame',
  ribbon,
}: PromoDialogProps) {
  const { t } = useT();
  return (
    <ResponsiveDialog
      open={open}
      onClose={onClose}
      title={title}
      maxWidth={460}
      presentation="modal"
    >
      <PromoHero
        className={styles.dialogMarker}
        icon={icon}
        title={title}
        subtitle={text}
        tier={tier}
        ribbon={ribbon}
        compact
      />
      <ul className={styles.benefits} aria-label={title}>
        {benefits.map((benefit, index) => (
          // index erlaubt den Items, eine eigene aria-Position zu sein —
          // das aendert nichts an der Lesereihenfolge.
          // eslint-disable-next-line react/no-array-index-key
          <li key={index} className={styles.benefit}>
            <Icon className={styles.benefitIcon} name="check" size={18} />
            <span>{benefit}</span>
          </li>
        ))}
      </ul>
      <div className={styles.actions}>
        <PromoCta tier={tier} onClick={onCta} fullWidth>
          {ctaLabel}
        </PromoCta>
        <button
          type="button"
          className={styles.later}
          onClick={onClose}
        >
          {laterLabel ?? t('promo.later')}
        </button>
      </div>
    </ResponsiveDialog>
  );
}

export default PromoDialog;
